import { Dropdown, Input, Menu } from "antd"
import { FC, memo, useMemo, useState } from "react"
import { SearchButton } from "../../../buttons/iconButtons/action/MainCollection"
import { IOption } from "../../../selects/select"
import styles from "../styles/DocumentSearchPanelAntd.module.scss"

interface ISearchParams {
    searchStore: string
    searchOption: string
}

interface IBaseProps {
    onSubmit: (searchParams: ISearchParams) => void
    options?: IOption[]
    selectedItem?: [IGridRow | undefined, (value: IGridRow | undefined) => void]
}

interface IDocumentSearchPanelProps extends IBaseProps {}

interface ISearchFormProps extends IBaseProps {
    memoizedOptions: IOption[]
}

export const DocumentSearchPanelAntd: FC<IDocumentSearchPanelProps> = ({ options, children, ...rest }) => {
    const memoizedOptions = useMemo(() => options || [{ displayName: "Содержит товар", value: "goodsName" }], [options])

    return (
        <>
            <SearchForm memoizedOptions={memoizedOptions} {...rest} />
        </>
    )
}

const SearchForm: FC<ISearchFormProps> = memo(({ memoizedOptions, onSubmit, selectedItem }) => {
    const [searchStore, setSearchStore] = useState<string>("")
    const [searchOption, setSearchOption] = useState<IOption>(memoizedOptions[0])
    const [dropdownVisible, setDropdownVisible] = useState(false)

    const handleSubmit = (event?: React.FormEvent) => {
        event?.preventDefault()
        selectedItem?.[1](undefined)
        if (onSubmit) {
            onSubmit({ searchStore, searchOption: searchOption.value as string })
        }
    }
    
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            e.preventDefault() // Предотвращаем действие по умолчанию
            setDropdownVisible(false) // Скрываем dropdown
            handleSubmit()
        }
    }

    const menu = (
        <Menu
            className={styles.searchForm__menu}
            selectedKeys={[searchOption.value]}
            onClick={({ key }) => {
                const selected = memoizedOptions.find((option) => option.value === key)
                if (selected) {
                    setSearchOption(selected)
                    setDropdownVisible(false)
                }
            }}
            onBlur={handleSubmit}
        >
            {memoizedOptions.map((option) => (
                <Menu.Item key={option.value}>{option.displayName}</Menu.Item>
            ))}
        </Menu>
    )

    return (
        <form className={styles.searchForm} onSubmit={handleSubmit}>
            <div className={styles.searchForm__container}>
                <Input
                    className={styles.searchForm__input}
                    value={searchStore}
                    onChange={(e) => setSearchStore(e.target.value)}
                    onKeyDown={handleKeyDown}
                    addonAfter={
                        <Dropdown
                        onOpenChange={(visible) => {
                            setDropdownVisible(visible)
                        }}
                        className={styles.searchForm__dropdown}
                        overlay={menu}
                        trigger={["click"]}
                        open={dropdownVisible}>
                            <div className={styles.searchForm__dropdownButton}>
                                <SearchButton
                                    buttonType={"submit"}
                                    sizeVariant={"normal"}
                                    onClick={(e) => {
                                        e.preventDefault()
                                        setDropdownVisible(!dropdownVisible)
                                    }}
                                />
                            </div>
                            
                        </Dropdown>
                    }
                    placeholder={searchOption.displayName}
                />
            </div>
        </form>
    )
})
